<template>
  <div class="group_standard">
    <div class="antd-row">
      <div class="antd-col left" :span="12">
        <div class="header">
          <div class="header_title" @click.stop="submitPublish('ceppeaPublish')">已发布CEPPEA标准</div>
          <PublishingStandard @click.native.stop="submitPublishDetails('ceppeaPublish')" />
        </div>
      </div>
      <div class="antd-col right" :span="12">
        <div class="header">
          <div class="header_title" @click.stop="submitSolicit('ceppeaSolicit')">CEPPEA标准征求意见</div>
          <Idea @click.native.stop="submitSolicit('ceppeaSolicit')" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Idea from './idea'; // CEPPEA标准征求意见
import PublishingStandard from './publishingStandard'; // 已发布CEPPEA标准
export default {
  components: { PublishingStandard, Idea },
  methods: {
    // 已发布CEPPEA标准
    submitPublish(path = "ceppeaPublish") {
      if (this.$FN.getUser()) {
        this.$FN.limitsTips({ list: ["home_groupStandard_publish"] }).then(res => {
          if (res) {
            this.$router.$push({ path })
          }
        });
      } else {
        this.$FN.LoginTips();
      }
    },
    submitPublishDetails(path = "ceppeaPublish") {
      if (this.$FN.getUser()) {
        this.$FN.limitsTips({ list: ["home_groupStandard_details"] }).then(res => {
          if (res) {
            this.$router.$push({ path })
          }
        });
      } else {
        this.$FN.LoginTips();
      }
    },
    // CEPPEA标准征求意见
    submitSolicit(path = "ceppeaSolicit") {
      if (this.$FN.getUser()) {
        this.$FN.limitsTips({ list: ["home_groupStandard_idea"] }).then(res => {
          if (res) {
            this.$router.$push({ path })
          }
        });
      } else {
        this.$FN.LoginTips();
      }
    }
    // submit(path = "ceppeaPublish") {
    //   if (this.$FN.getUser()) {
    //     let key = path === "ceppeaPublish" ? 'home_groupStandard_details' : 'home_groupStandard_idea';
    //     this.$FN.limitsTips({ list: [key] }).then(res => {
    //       if (res) {
    //         this.$router.$push({ path })
    //       }
    //     });
    //   } else {
    //     this.$FN.LoginTips();
    //   }
    // }
  }
}
</script>

<style lang="less" scoped>
@import url("./index.less");
</style>